{
	"event": "Événement",
	"logout": "Déconnexion",
	"org": "Organisation",
	"place": "Lieu",
	"language": "Langue"
}
